import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { EventData } from 'src/app/interfaces/agent.interface';
import { AppConfig } from 'src/app/services/app.config.services';
import { TrsEventsService } from 'src/app/services/trsevents.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.sass']
})
export class DashboardComponent implements OnInit {
  srcUrl: any;
  appConfig = AppConfig;
  isDashboardAlreadyOpened: boolean = false;

  constructor(private sanitizer: DomSanitizer, private trsService: TrsEventsService) { }

  subscribeToEvents = (): void => {
    this.trsService.evtDataObservable.subscribe((response: EventData) => {
      switch (response.eventName) {
        case "DASHBOARD_MODE":
          if (response.data.dashboardView === true && this.isDashboardAlreadyOpened === false) {
            this.loadDashboard();
            this.isDashboardAlreadyOpened = true;
          }
          break;
        case "GAMIFICATION_MODE":
          break;
        case "LOGOUT_SUPERVISOR":
          this.isDashboardAlreadyOpened = false
          this.srcUrl = "#";
          break;
      }
    });
  }

  ngOnInit(): void {
    this.subscribeToEvents();
    this.srcUrl = "#";
  }

  loadDashboard = (): void => {
    let url: string = this.appConfig.settings.Dashboard.Url;
    if (url != null && url !== "") {
      url = url.split('=')[0];
      url = `${url}=${this.trsService.supervisorId}`;
    }
    this.srcUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }
}
